export const LIST_CARD_IMAGE_UNAVAILABLE = 'https://images.dickssportinggoods.com/marketing/listCardImageUnavailable.svg';
